export default {"src":"https://assets-v2.i-scmp.com/production/_next/static/media/spinner.3170e5c7.gif","height":480,"width":475,"blurWidth":0,"blurHeight":0};